import { Button } from "../../components/Button"
import ModalAlert from "../../components/ModalAlert"

export const LatestAppointmentsExecuteScreen = ({ handleEventStatus }) => {
  return (
    <div>
      <Button
        label="Executar Agora"
        color="orange"
        handleClick={() => {
          ModalAlert.warn({
            title: "Deseja continuar com a execução?",
            confirmLabel: "Sim",
            onConfirm: () => handleEventStatus(),
          })
        }}
      />
    </div>
  )
}